// Only OnboardingRuntime acquires ownership after its DEV + organization + identity gates.
const owners=new Set<symbol>();
const legacyCancellations=new Set<()=>void>();
export function legacyToursSuppressed():boolean{return owners.size>0;}
export function acquireFluTourOwnership():()=>void{
 const owner=Symbol('flu-onboarding');owners.add(owner);
 for(const cancel of [...legacyCancellations]){
  legacyCancellations.delete(cancel);
  try{cancel();}catch{/* A legacy presentation cannot prevent the new owner from mounting. */}
 }
 return()=>{owners.delete(owner);};
}
export function watchLegacyTourCancellation(cancel:()=>void):()=>void{
 if(legacyToursSuppressed()){cancel();return()=>{};}
 legacyCancellations.add(cancel);
 return()=>{legacyCancellations.delete(cancel);};
}
